import React, { useState } from "react";
import Dropdown from "../../../components/Dropdown";
import OneCheckBox from "../../../components/OneCheckBox";
import ButtonPrimary from "../../../components/ButtonPrimary";
import TableLogComponents from "../../../components/TableLogComponents";
export default function AddATKResultDialog({
  isShow,
  backgroundClick,
  cancelClick,
  dataSource,
  columnsDataSource
}) {
  return (
    <div className="box-position-dialog" id={isShow ? "show-dialog" : ""}>
      <div
        className="box-cover-dialog-background"
        onClick={backgroundClick}
      ></div>
      <div className="box-dialog">
        <div className="row-jcct-pt2">
          <p style={{ color: "#134e96" }} className="txt-main-content4">
            Add ATK Result
          </p>
        </div>
        <div className="box-table-inside-dialog">
          <TableLogComponents
            columns={[
              {
                title: "No",
                dataIndex: "no",
                key: "no",
              },
              {
                title: "First Name",
                dataIndex: "firstname",
                key: "firstname",
              },
              {
                title: "Last Name",
                dataIndex: "lastname",
                key: "lastname",
              },
              {
                title: "ID",
                dataIndex: "id",
                key: "id",
              },
            ]}
            dataSource={[
              {
                no: "1",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "2",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "3",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "4",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
            ]}
          />
        </div>
        <div className="row-jcsb-px2-gab2">
          <div className="col-jcfs">
            <p className="txt-main-content4">Covid Result</p>
            <Dropdown
              items={["Negative", "Positive"]}
              itemCallback={(item) => {
                console.log(item);
              }}
              hasFilter={false}
            />
          </div>
          <div className="col-aict-gab2">
            <div className="col-jcfs">
              <OneCheckBox callBack={(state) => {}} title={"Leave at home"} />
              <div className="row-jcct-gab2">
                <input className="text-field"></input>
                <p className="txt-main-content4">Days</p>
              </div>
            </div>
            <div className="col-jcfs">
              <OneCheckBox
                callBack={(state) => {}}
                title={"Leave at the Nursing room"}
              />
              <div className="row-jcct-gab2">
                <input className="text-field"></input>
                <p className="txt-main-content4">Hours</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row-jcct-py2-gab2">
          <ButtonPrimary
            text={"Cancel"}
            className={"text-button"}
            onClick={cancelClick}
          />
          <ButtonPrimary text={"Ok"} className={"primary-button2"} />
        </div>
      </div>
    </div>
  );
}
